<h2 mat-dialog-title style="width: 400px; max-width: 90vw; text-align: center;">
  {{dialogTitle ? dialogTitle : ('QR_SCAN_TITLE' | translate)}}
</h2>
<mat-dialog-content style="width: 400px; max-width: 90vw; text-align: center;">
  <qrcode *ngIf="needQrTransformation && qrCodeUri" [qrdata]="qrCodeUri" [width]="220" [errorCorrectionLevel]="'M'"></qrcode>
  <img *ngIf="!needQrTransformation && qrCodeUri" [src]="qrCodeUri" alt="QR Code" style="width: 220px; height: 220px;"/>
  <hr style="margin: 15px 0px; width: 100%;">
  <div *ngIf="alternativeButtonText && alternativeButtonLink" style="margin: 12px 0px;">
    <a [href]="alternativeButtonLink" target="_blank" rel="noopener">
      <button mat-button style="font-size: 16px; height: 64px;">{{ alternativeButtonText }}</button>
    </a>
  </div>
  <p *ngIf="dialogMessage" style="width: 100%;">{{ dialogMessage }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button style="margin: auto;" (click)="dialogRef.close()">{{'CLOSE' | translate}}</button>
</mat-dialog-actions>
